<template>
<div>
<v-card style="width:100%;height:90px" class="secondary">
     <v-layout row wrap style="height:40px;">
      <v-flex xs10 style="padding:10px;" >
            <div class="title" style="color:white">Daily Statement</div>
      </v-flex>
      <v-flex xs2>
      <v-btn @click="fetchstatement" icon style="float:right"><v-icon style="margin-top:0px" color="white">refresh</v-icon></v-btn>
      </v-flex>
    </v-layout>
     <v-layout row wrap style="height:40px;">
      <v-flex xs12 style="padding-top:8px" >
      <input type="text" style="float:left;width:200px;"  v-model="search"  class="search" placeholder="Search All Column" >
         <v-btn class="success searchbtn" @click="fetchstatement"> Search</v-btn>
    <v-menu
        :close-on-content-click="false"
        v-model="menu2"
        lazy
        transition="scale-transition"
        offset-y
        style="float:right"
        >
         <input type="text" slot="activator"  v-model="date2" readonly class="search" placeholder="To Date" >
        <v-date-picker v-model="date2" @input="menu2 = false"></v-date-picker>
      </v-menu>
    <v-menu
        :close-on-content-click="false"
        v-model="menu1"
        lazy
        transition="scale-transition"
        offset-y
        style="float:right"
        >
         <input type="text" slot="activator"  v-model="date1" readonly class="search" placeholder="From Date" >
        <v-date-picker v-model="date1" @input="menu1 = false"></v-date-picker>
      </v-menu>
      </v-flex>
    </v-layout>
</v-card>
<v-data-table
      :headers="headers"
      :items="statementlist"
      :search="search"
    >
      <template slot="items" slot-scope="props">
        <td>{{ new Date(parseInt(props.item.date)) | moment("DD-MM-YYYY")}}</td>
        <td >{{ props.item.opening_balance }}</td>
        <td >{{ props.item.walletp }}</td>
        <td >{{ props.item.walletm }}</td>
        <td >{{ props.item.admintransfer }}</td>
        <td >{{ props.item.bhimupi }}</td>
        <td >{{ props.item.revertp }}</td>
        <td >{{ props.item.revertm }}</td>       
        <td >{{ props.item.recharge }}</td>
        <td >{{ props.item.refund }}</td>
        <td >{{ props.item.withdrawal }}</td>
        <td >{{ props.item.surcharge_amountp }}</td>
        <td >{{ props.item.surcharge_amountm }}</td>
        <td >{{ props.item.commission_amountp }}</td>
        <td >{{ props.item.commission_amountm }}</td>
        <td >{{ props.item.REFERRAL_COMMISSIONP }}</td>
        <td >{{ props.item.REFERRAL_COMMISSIONM }}</td>
        <td >{{ props.item.peerp }}</td>
        <td >{{ props.item.peerm }}</td>
        <td >{{ props.item.aepsp }}</td>
        <td >{{ props.item.aepsm }}</td>        
        <td >{{ props.item.closing_balance }}</td>
      </template>
    </v-data-table>

  <v-dialog v-model="dialog" persistent width="300"><v-card color="primary" dark><v-card-text>Please wait <v-progress-linear indeterminate  color="white" class="mb-0"/></v-card-text></v-card></v-dialog>
</div>
</template>


<script>
export default {
   data(){
      return{
            headers: [
                { text: 'Statement Date', value: 'date',align: 'left',sortable: false},
                { text: 'Opening Balance', value: 'opening_balance' },
                { text: 'Wallet(+)', value: 'walletp' },
                { text: 'Wallet(-)', value: 'walletm' },
                { text: 'Admin Transfer', value: 'admintransfer' },
                { text: 'BhimUPI', value: 'bhimupi' },
                { text: 'Revert(+)', value: 'revertp' },
                { text: 'Revert(-)', value: 'revertm' },         
                { text: 'Recharge', value: 'recharge' },
                { text: 'Refund', value: 'refund' },
                { text: 'Withdrawal', value: 'withdrawal' },
                { text: 'Surcharge(NA)', value: 'surcharge_amountp' },
                { text: 'Surcharge(NA)', value: 'surcharge_amountm' },
                { text: 'Commission(NA)', value: 'commission_amountp' },
                { text: 'Commission(NA)', value: 'commission_amountm' },
                { text: 'REFERRAL(+)', value: 'REFERRAL_COMMISSIONP' },
                { text: 'REFERRAL(-)', value: 'REFERRAL_COMMISSIONM' },
                { text: 'Peer(+)', value: 'peerp' },
                { text: 'Peer(-)', value: 'peerm' },
                { text: 'Aeps(+)', value: 'aepsp' },
                { text: 'Aeps(-)', value: 'aepsm' },              
                { text: 'Closing Balance', value: 'closing_balance' },
            ],
            dialog:false,
            statementlist:[],
            modal:false,
            search:'',
            date1:'',
            menu1:false,
            date2:'',
            menu2:false,
      }
   },
   computed:{
      user(){
         return this.$store.getters.user;
      }
   },
   methods:{
     notification(type,message){
        this.$notify({
                group: 'foo',
                title: 'Important message',
                text: message,
                duration:5000,
                type:type
        })
      },
      pushstatement(value){
         let vm = this;
            vm.statementlist = []
            for(let i =0;i<value.length;i++){
               let doc = value[i]
               let time = doc.CreatedDate.replace("/Date(","").replace(")/","")
               vm.statementlist.push({
                  date: time,
                  opening_balance:doc.Opening_Balance,
                  walletp:doc.WalletP,
                  walletm:doc.WalletM,
                  admintransfer:doc.AdminTransfer,
                  bhimupi:doc.BhimUpi,
                  revertp:doc.RevertP,
                  revertm:doc.RevertM,
                  recharge:doc.Recharge,
                  refund:doc.Refund,
                  withdrawal:doc.WithDrawal,
                  closing_balance:doc.Closing_Balance,
                  surcharge_amountp:doc.Surcharge_AmountP,
                  surcharge_amountm:doc.Surcharge_AmountM,
                  commission_amountp:doc.Commission_AmountP,
                  commission_amountm:doc.Commission_AmountM,
                  REFERRAL_COMMISSIONP:doc.REFERRAL_COMMISSIONP,
                  REFERRAL_COMMISSIONM:doc.REFERRAL_COMMISSIONM,
                  peerp:doc.PEERP,
                  peerm:doc.PEERM,
                  aepsp:doc.AEPSP,
                  aepsm:doc.AEPSM,
                  closing_balance:doc.Closing_Balance               
               })
            }

      },
      fetchstatement(){
         let vm = this;
         if(!vm.user.phone) return vm.notification("warn","Authentication Required!");
         let doc = {
           'MobileNo':vm.user.phone,
           'Password':vm.user.password,
           'AuthKey':vm.user.authkey,
           'getFromdate':vm.date1,
           'getTodate':vm.date2,
           'Source':'json'
           }
            vm.dialog = true;
            vm.$store.dispatch("axiospost",{
                  url:"Daily_Statement",
                  data:doc,
            }).then(function (res) {
                  console.log(res.data);

                  vm.dialog = false;
                  vm.pushstatement(res.data)
            }).catch(function (error) {
                  vm.notification("error",error.message);
                  vm.dialog = false;
            })
   }
   },
   mounted(){
      let vm = this;
      vm.fetchstatement()
   }
}
</script>

<style scoped>
.search{
   width:150px;
   float: right;
   margin-right: 10px;
   height: 34px;
   background: white;
   outline:none;
   margin-left:20px;
   padding-left:10px;
   font-size:1em;
}

.searchbtn{
   margin-right:15px;
   height: 34px;
   margin-left:20px;
   float: right;
   margin-top:0px;
}
</style>

